import React from 'react'
import styled from 'styled-components'
import Autocomplete from 'react-autocomplete'
import autocompleteData from './helpers/DocumentBucketAutocomplete'

const WrappedAutocomplete = props => { // Need to pass down className for styled-components
  return <Autocomplete {...props} inputProps={{ className: props.className, onFocus: props.onFocus, onBlur: props.onBlur }} />
}
const Input = styled(WrappedAutocomplete)`
 display: block;
 font-size: 11pt;
 padding: 4px 6px;
 height: 20px;
 border-radius: 4px;
 outline: none;
 border: 1px solid #ccc;
`
const Menu = styled.div`
  position: absolute;
  left: ${props => props.left}px;
  min-width: ${props => props.minWidth}px;
  background: white;
  z-index: 1;
  border: 1px solid #ccc;
`
const Item = styled.div`
  color: black;
  padding: 10px;
  &:hover {
    cursor: pointer;
    color: white;
    background: #75afb6;
  }
`

export default class DocumentBucketAutocomplete extends React.Component {
  constructor(){
    super()
    this.state = {
      shouldMenuOpen: false
    }
  }
  get items() {
    const { value } = this.props
    if (value === '') {
      return []
    } else {
      return Object.keys(autocompleteData).filter(item => item.toLowerCase().includes(value.toLowerCase())).slice(0, 6)
    }
  }
  renderItem = (item, isHighlighted) => {
    return <Item key={item} isHighlighted={isHighlighted}>{item}</Item>
  }
  renderMenu = (items, style) => {
    return (
      <Menu left={style.left} top={style.top} minWidth={style.minWidth}>
        {items}
      </Menu>
    )
  }
  render() {
    const { disabled, onChange, onSelect, value } = this.props
    const { shouldMenuOpen } = this.state
    const items = this.items
    return (
      <Input
        onFocus={ () => this.setState({shouldMenuOpen: true}) } 
        onBlur={ () => this.setState({shouldMenuOpen: false}) } 
        getItemValue={item => item}
        items={items}
        renderItem={this.renderItem}
        renderMenu={this.renderMenu}
        shouldItemRender={item => item.toLowerCase().includes(value.toLowerCase()) && value !== ''}
        disabled={disabled}
        onChange={onChange}
        value={value}
        open={items.length > 0 && !(value in autocompleteData) && shouldMenuOpen}
        onSelect={onSelect}
      />
    )
  }
}